import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';

export default class extends Controller {
  static targets = [
    'rate',
    'rateContainer'
  ]

  connect() {
    $(this.element).on('dataChange', this.updateTargets.bind(this))
  }

  updateTargets(_event, data) {
    if (data['status'] === 'available') {
      this.updateRate(data['rate']);
      this.updateHotelSearchPricePresenceValue(data['rate']);
    } else {
      let reason = data['reason'] || 'No rooms available'
      this.showUnavailabilityNotice(reason);
    }
  }

  updateRate(rate) {
    $(this.rateTarget).html(rate)
  }

  showUnavailabilityNotice(reason) {
    $(this.rateContainerTarget).html(`
      <span class='fw-medium text-danger'>
        ${reason.replace("\n", '</br>')}
      </span>
    `)
  }

  updateHotelSearchPricePresenceValue(rate) {
    const isPrice = !isNaN(parseFloat(rate));
    this.element.dataset['hotelSearchPricePresenceValue'] = isPrice;
  }
}
